import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/login', { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await axios.post(
          `${API}/google-auth/session`,
          { session_id },
          { withCredentials: true }
        );
        // Clear the hash from the URL so a refresh doesn't reprocess.
        try { window.history.replaceState(null, '', window.location.pathname); } catch { /* noop */ }
        // CRITICAL: refresh AuthContext BEFORE navigating so ProtectedRoute
        // sees `user` populated. Without this the user is bounced back to
        // /login because AuthContext's initial checkAuth was skipped while
        // the hash was present.
        await refreshUser();
        toast.success(`Welcome, ${res.data.name || res.data.email}!`);
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Auth callback failed:', err);
        const detail = err?.response?.data?.detail;
        const status = err?.response?.status;
        // Preserve the venue-not-found message the backend now returns so
        // an admin who typos a client email gets a clear "no account found"
        // instead of a generic "sign-in failed".
        const msg = (status === 404 && typeof detail === 'string')
          ? detail
          : (typeof detail === 'string' ? detail : 'Sign-in failed. Please try again.');
        toast.error(msg);
        navigate('/login', { replace: true });
      }
    })();
  }, [location.hash, navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-[#000000] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-white text-lg">Signing you in…</div>
    </div>
  );
};

export default AuthCallback;
